"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "val-liona": {
    "5c9c58b2": [{
      "hkey": "56564841",
      "slug": "san-germano-dei-berici-carbonarola",
      "name": "San Germano dei Berici-Carbonarola",
      "primary": true,
      "skipSearch": false
    }],
    "carbonarolla": [{
      "hkey": "56564841",
      "slug": "san-germano-dei-berici-carbonarola",
      "name": "San Germano dei Berici-Carbonarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "val-liona"
    }],
    "dac7e03b": [{
      "hkey": "56564841",
      "slug": "san-germano-dei-berici-carbonarola",
      "name": "San Germano dei Berici-Carbonarola",
      "primary": true,
      "skipSearch": false
    }],
    "carbonarola": [{
      "hkey": "56564841",
      "slug": "san-germano-dei-berici-carbonarola",
      "name": "San Germano dei Berici-Carbonarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "val-liona"
    }],
    "7268c692": [{
      "hkey": "56564841",
      "slug": "san-germano-dei-berici-carbonarola",
      "name": "San Germano dei Berici-Carbonarola",
      "primary": true,
      "skipSearch": false
    }],
    "san-germano-dei-berici": [{
      "hkey": "56564841",
      "slug": "san-germano-dei-berici-carbonarola",
      "name": "San Germano dei Berici-Carbonarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3a6da2c5": [{
      "hkey": "3f0c8dd2",
      "slug": "val-liona",
      "name": "Val Liona",
      "primary": true,
      "skipSearch": false
    }],
    "acque": [{
      "hkey": "3f0c8dd2",
      "slug": "val-liona",
      "name": "Val Liona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;